export default __webpack_public_path__ + "static/media/form1.d60cb061.png";